import Layout from '@layout/Index'

export const receivedPayment = [
  {
    path: '/received-payment',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "received-payment-table" */ './pages/ReceivedPaymentTable.vue'),
        meta: {
          title: '回款列表',
          type: 'payment',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "received-payment-detail" */ './pages/ReceivedPaymentDetail.vue'),
        meta: {
          title: '回款详情',
          type: 'payment',
        },
      },
      {
        path: 'detail-redirect/:id',
        component: () => import(/* webpackChunkName: "received-payment-detail-redirect" */ './pages/ReceivedPaymentDetailRedirect.vue'),
        name: '回款详情跳转页面',
        meta: {
          title: '回款详情跳转页面',
        },
      },
    ],
  },
  {
    path: '/received-approval',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "received-payment-table" */ './pages/ReceivedPaymentTable.vue'),
        meta: {
          title: '财务回款列表',
          type: 'approval',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "received-payment-form" */ './pages/ReceivedPaymentForm.vue'),
        meta: {
          title: '财务新增回款',
          type: 'approval',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "received-payment-form" */ './pages/ReceivedPaymentForm.vue'),
        meta: {
          title: '财务修改回款',
          type: 'approval',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "received-payment-detail" */ './pages/ReceivedPaymentDetail.vue'),
        meta: {
          title: '财务回款详情',
          type: 'approval',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/received-payment/received-payment.route.js